(function () {
  var page = document.querySelector('.zm-page');
  if (!page) return;
  var input = page.querySelector('#zm-q');
  var status = page.querySelector('.zm-status');
  var blocks = Array.prototype.slice.call(page.querySelectorAll('.zm-block'));
  var links = Array.prototype.slice.call(page.querySelectorAll('.zm-index a'));
  if (!input || !blocks.length) return;

  function apply() {
    var q = input.value.trim().toLowerCase();
    var shown = 0;
    blocks.forEach(function (block, i) {
      var hit = !q || block.textContent.toLowerCase().indexOf(q) !== -1;
      block.classList.toggle('zm-hide', !hit);
      if (links[i]) links[i].classList.toggle('zm-hide', !hit);
      if (hit) shown += 1;
    });
    if (status) {
      status.textContent = q ? shown + ' section' + (shown === 1 ? '' : 's') + ' match “' + input.value.trim() + '”' : '';
    }
  }
  input.addEventListener('input', apply);
})();
